export const TRAVEL_INSURANCE_FORM = 'travelKe/quoteForm/';
export const UG_MOTOR_QOUTE_FORM = 'travelKe/quoteForm/';
export const TRAVEL_INSURANCE_FORM_SET_VALUE = TRAVEL_INSURANCE_FORM + 'setValue';
export const TRAVEL_INSURANCE_FORM_SET_VALID = TRAVEL_INSURANCE_FORM + 'setValid';
export const REINITIALIZE = TRAVEL_INSURANCE_FORM + '/state/reinitialize';
export const FORM_VALID_TRAVEL_INSURANCE_FORM = TRAVEL_INSURANCE_FORM + 'formValid';
export const FORM_INVALID_TRAVEL_INSURANCE_FORM = TRAVEL_INSURANCE_FORM + 'formInValid';
export const FORM_VALID_TRAVEL_INSURANCE_QUOTE_SHARE_FORM = TRAVEL_INSURANCE_FORM + 'shareFormValid';
export const FORM_INVALID_TRAVEL_INSURANCE_QUOTE_SHARE_FORM = TRAVEL_INSURANCE_FORM + 'shareFormValid';

export const SET_SHARE_EMAIL_VALUE = TRAVEL_INSURANCE_FORM_SET_VALUE + 'shareEmailValue';
export const SET_SHARE_EMAIL_VALID = TRAVEL_INSURANCE_FORM_SET_VALID + 'shareEmailValid';
export const TOKEN_IS_EXPIRED = 'travelKe/expiredAuth';

export const transitionTravelInsuranceQuoteForm = {
    formValid: () => ({
        type: FORM_VALID_TRAVEL_INSURANCE_FORM,
    }),
    formInvalid: () => ({
        type: FORM_INVALID_TRAVEL_INSURANCE_FORM,
    }),
};

export const transitionShareQuoteForm = {
    formInvalid: () => ({
        type: FORM_VALID_TRAVEL_INSURANCE_QUOTE_SHARE_FORM,
    }),
    formValid: () => ({
        type: FORM_INVALID_TRAVEL_INSURANCE_QUOTE_SHARE_FORM,
    }),
};

// API Calls actions
export const API_INITIAL_TRANSITION_TRAVEL_INSURANCE_QUOTE_FORM = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/apiTransition/initial`;
export const API_PENDING_TRANSITION_TRAVEL_INSURANCE_QUOTE_FORM = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/apiTransition/pending`;
export const API_SUCCESS_TRANSITION_TRAVEL_INSURANCE_QUOTE_FORM = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/apiTransition/success`;
export const API_FAILURE_TRANSITION_TRAVEL_INSURANCE_QUOTE_FORM = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/apiTransition/failure`;
export const API_PENDING_TRANSITIONS_SHARE_QUOTE_FORM = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/shareQuote/apiTransition/pending`;
export const API_SUCCESS_TRANSITIONS_SHARE_QUOTE_FORM = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/shareQuote/apiTransition/success`;
export const API_FAILURE_TRANSITIONS_SHARE_QUOTE_FORM = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/shareQuote/apiTransition/failure`;
export const API_COUNTRIES_PENDING_TRANSITION = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/apiTransition/countries/pending`;
export const API_COUNTRIES_SUCCESS_TRANSITION = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/apiTransition/countries/success`;
export const API_COUNTRIES_FAILURE_TRANSITION = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/apiTransition/countries/failure`;

export const API_BENEFITS_EUROPE_PENDING_TRANSITION = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/apiTransition/benefitsEurope/pending`;
export const API_BENEFITS_EUROPE_SUCCESS_TRANSITION = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/apiTransition/benefitsEurope/success`;
export const API_BENEFITS_EUROPE_FAILURE_TRANSITION = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/apiTransition/benefitsEurope/failure`;

export const API_BENEFITS_WORLD_WIDE_PENDING_TRANSITION = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/apiTransition/benefitsWorldWide/pending`;
export const API_BENEFITS_WORLD_WIDE_SUCCESS_TRANSITION = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/apiTransition/benefitsWorldWide/success`;
export const API_BENEFITS_WORLD_WIDE_FAILURE_TRANSITION = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/apiTransition/benefitsWorldWide/failure`;

export const API_BENEFITS_AFRICA_PENDING_TRANSITION = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/apiTransition/benefitsAfrica/pending`;
export const API_BENEFITS_AFRICA_SUCCESS_TRANSITION = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/apiTransition/benefitsAfrica/success`;
export const API_BENEFITS_AFRICA_FAILURE_TRANSITION = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/apiTransition/benefitsAfrica/failure`;

export const API_BENEFITS_ASIA_PENDING_TRANSITION = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/apiTransition/benefitsAsia/pending`;
export const API_BENEFITS_ASIA_SUCCESS_TRANSITION = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/apiTransition/benefitsAsia/success`;
export const API_BENEFITS_ASIA_FAILURE_TRANSITION = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/apiTransition/benefitsAsia/failure`;

export const API_BENEFITS_STUDENTS_PENDING_TRANSITION = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/apiTransition/benefitsStudents/pending`;
export const API_BENEFITS_STUDENTS_SUCCESS_TRANSITION = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/apiTransition/benefitsStudents/success`;
export const API_BENEFITS_STUDENTS_FAILURE_TRANSITION = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/apiTransition/benefitsStudents/failure`;

export const API_BENEFITS_PILGRIMAGE_PENDING_TRANSITION = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/apiTransition/benefitsPilgrimage/pending`;
export const API_BENEFITS_PILGRIMAGE_SUCCESS_TRANSITION = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/apiTransition/benefitsPilgrimage/success`;
export const API_BENEFITS_PILGRIMAGE_FAILURE_TRANSITION = `${TRAVEL_INSURANCE_FORM_SET_VALUE}/apiTransition/benefitsPilgrimage/failure`;

export const apiTransitionTravelInsuranceQuoteForm = {
    initial: () => ({
        type: API_INITIAL_TRANSITION_TRAVEL_INSURANCE_QUOTE_FORM,
    }),
    pending: () => ({
        type: API_PENDING_TRANSITION_TRAVEL_INSURANCE_QUOTE_FORM,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_TRAVEL_INSURANCE_QUOTE_FORM,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_TRAVEL_INSURANCE_QUOTE_FORM,
    }),
};

export const apiTransitionCountries = {
    pending: () => ({
        type: API_COUNTRIES_PENDING_TRANSITION,
    }),
    success: () => ({
        type: API_COUNTRIES_SUCCESS_TRANSITION,
    }),
    failure: () => ({
        type: API_COUNTRIES_FAILURE_TRANSITION,
    }),
};

export const apiTransitionBenefitsEurope = {
    pending: () => ({
        type: API_BENEFITS_EUROPE_PENDING_TRANSITION,
    }),
    success: () => ({
        type: API_BENEFITS_EUROPE_SUCCESS_TRANSITION,
    }),
    failure: () => ({
        type: API_BENEFITS_EUROPE_FAILURE_TRANSITION,
    }),
};

export const apiTransitionBenefitsWorldWide = {
    pending: () => ({
        type: API_BENEFITS_WORLD_WIDE_PENDING_TRANSITION,
    }),
    success: () => ({
        type: API_BENEFITS_WORLD_WIDE_SUCCESS_TRANSITION,
    }),
    failure: () => ({
        type: API_BENEFITS_WORLD_WIDE_FAILURE_TRANSITION,
    }),
};

export const apiTransitionBenefitsAfrica = {
    pending: () => ({
        type: API_BENEFITS_AFRICA_PENDING_TRANSITION,
    }),
    success: () => ({
        type: API_BENEFITS_AFRICA_SUCCESS_TRANSITION,
    }),
    failure: () => ({
        type: API_BENEFITS_AFRICA_FAILURE_TRANSITION,
    }),
};

export const apiTransitionBenefitsAsia = {
    pending: () => ({
        type: API_BENEFITS_ASIA_PENDING_TRANSITION,
    }),
    success: () => ({
        type: API_BENEFITS_ASIA_SUCCESS_TRANSITION,
    }),
    failure: () => ({
        type: API_BENEFITS_ASIA_FAILURE_TRANSITION,
    }),
};

export const apiTransitionBenefitsStudents = {
    pending: () => ({
        type: API_BENEFITS_STUDENTS_PENDING_TRANSITION,
    }),
    success: () => ({
        type: API_BENEFITS_STUDENTS_SUCCESS_TRANSITION,
    }),
    failure: () => ({
        type: API_BENEFITS_STUDENTS_FAILURE_TRANSITION,
    }),
};

export const apiTransitionBenefitsPilgrimage = {
    pending: () => ({
        type: API_BENEFITS_PILGRIMAGE_PENDING_TRANSITION,
    }),
    success: () => ({
        type: API_BENEFITS_PILGRIMAGE_SUCCESS_TRANSITION,
    }),
    failure: () => ({
        type: API_BENEFITS_PILGRIMAGE_FAILURE_TRANSITION,
    }),
};

export const apiTransitionShareQuoteForm = {
    pending: () => ({
        type: API_PENDING_TRANSITIONS_SHARE_QUOTE_FORM,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITIONS_SHARE_QUOTE_FORM,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITIONS_SHARE_QUOTE_FORM,
    }),
};

// //calculated Data
export const COLLECT_TRAVEL_INSURANCE_QUOTE_FORM_DATA =
    TRAVEL_INSURANCE_FORM_SET_VALUE + 'collectTravelInsuranceQuoteData';
export const UPDATE_TRAVEL_INSURANCE_QUOTE_FORM_DATA =
    TRAVEL_INSURANCE_FORM_SET_VALUE + 'updateTravelInsuranceQuoteData';
export const TRAVEL_INSURANCE_ADD_COVER = TRAVEL_INSURANCE_FORM_SET_VALUE + 'addCover';
// export const COLLECT_KE_MOTOR_INSURANCE_QUOTE_FORM_DATA = KE_MOTOR_QUOTE_FORM + 'collectMotorInsuranceQuoteData';
// export const COLLECT_KE_THIRD_PARTY_DATA = KE_MOTOR_QUOTE_FORM + 'collectMotorInsuranceThirdPartyQuoteData';
// export const SUBMIT_MOTOR_INSURANCE_QUOTE_SUCCESS = UG_MOTOR_QOUTE_FORM_SET_VALUE + 'success';
// export const SUBMIT_MOTOR_INSURANCE_QUOTE_FAILURE = UG_MOTOR_QOUTE_FORM_SET_VALUE + 'failure';
export const CALCULATE_TRAVEL_INSURANCE_PREMIUM_SUCCESS = TRAVEL_INSURANCE_FORM_SET_VALUE + 'calculatePremiumSuccess';
export const CALCULATE_TRAVEL_INSURANCE_PREMIUM_FAILURE = TRAVEL_INSURANCE_FORM_SET_VALUE + 'failure';
export const COLLECT_SHARE_QUOTE_FORM_DATA = TRAVEL_INSURANCE_FORM_SET_VALUE + 'collectShareQuoteFormData';
export const SHARE_MOTOR_INSURANCE_QUOTE_SUCCESS = TRAVEL_INSURANCE_FORM_SET_VALUE + 'shareQuoteSuccess';
export const SHARE_MOTOR_INSURANCE_QUOTE_FAILURE = TRAVEL_INSURANCE_FORM_SET_VALUE + 'shareQuoteFailure';
export const TRIGGER_FETCH_ALL_COUNTRIES = TRAVEL_INSURANCE_FORM_SET_VALUE + 'fetchAllCountries';
export const FETCH_ALL_COUNTRIES_SUCCESS = TRAVEL_INSURANCE_FORM + 'fetchAllCountries/success';
export const FETCH_ALL_COUNTRIES_FAILURE = TRAVEL_INSURANCE_FORM + 'fetchAllCountries/failure';
export const FETCH_ALL_COUNTRIES_PENDING = TRAVEL_INSURANCE_FORM + 'fetchAllCountries/pending';
export const TRIGGER_FETCH_BENEFITS_EUROPE = TRAVEL_INSURANCE_FORM_SET_VALUE + 'fetchBenefitsEurope';
export const TRIGGER_FETCH_BENEFITS_WORLDWIDE = TRAVEL_INSURANCE_FORM_SET_VALUE + 'fetchBenefitsWorldWide';
export const TRIGGER_FETCH_BENEFITS_AFRICA = TRAVEL_INSURANCE_FORM_SET_VALUE + 'fetchBenefitsAfrica';
export const TRIGGER_FETCH_BENEFITS_ASIA = TRAVEL_INSURANCE_FORM_SET_VALUE + 'fetchBenefitsAsia';
export const TRIGGER_FETCH_BENEFITS_STUDENTS = TRAVEL_INSURANCE_FORM_SET_VALUE + 'fetchBenefitsStudent';
export const TRIGGER_FETCH_BENEFITS_PILGRIMAGE = TRAVEL_INSURANCE_FORM_SET_VALUE + 'fetchBenefitsPilgrimage';
export const PLAN = TRAVEL_INSURANCE_FORM_SET_VALUE + '/plans';
export const SEGMENT = TRAVEL_INSURANCE_FORM_SET_VALUE + '/segment';
export const SECTION = TRAVEL_INSURANCE_FORM_SET_VALUE + '/section';

export const FETCH_BENEFITS_EUROPE_SUCCESS = TRAVEL_INSURANCE_FORM + 'fetchBenefitsEurope/success';
export const FETCH_BENEFITS_EUROPE_FAILURE = TRAVEL_INSURANCE_FORM + 'fetchBenefitsEurope/failure';
export const FETCH_BENEFITS_EUROPE_PENDING = TRAVEL_INSURANCE_FORM + 'fetchBenefitsEurope/pending';

export const FETCH_BENEFITS_WORLD_WIDE_SUCCESS = TRAVEL_INSURANCE_FORM + 'fetchBenefitsWorldwide/success';
export const FETCH_BENEFITS_WORLD_WIDE_FAILURE = TRAVEL_INSURANCE_FORM + 'fetchBenefitsWorldwide/failure';
export const FETCH_BENEFITS_WORLD_WIDE_PENDING = TRAVEL_INSURANCE_FORM + 'fetchBenefitsWorldwide/pending';

export const FETCH_BENEFITS_AFRICA_SUCCESS = TRAVEL_INSURANCE_FORM + 'fetchBenefitsAfrica/success';
export const FETCH_BENEFITS_AFRICA_FAILURE = TRAVEL_INSURANCE_FORM + 'fetchBenefitsAfrica/failure';
export const FETCH_BENEFITS_AFRICA_PENDING = TRAVEL_INSURANCE_FORM + 'fetchBenefitsAfrica/pending';

export const FETCH_BENEFITS_ASIA_SUCCESS = TRAVEL_INSURANCE_FORM + 'fetchBenefitsAsia/success';
export const FETCH_BENEFITS_ASIA_FAILURE = TRAVEL_INSURANCE_FORM + 'fetchBenefitsAsia/failure';
export const FETCH_BENEFITS_ASIA_PENDING = TRAVEL_INSURANCE_FORM + 'fetchBenefitsAsia/pending';

export const FETCH_BENEFITS_STUDENTS_SUCCESS = TRAVEL_INSURANCE_FORM + 'fetchBenefitsStudents/success';
export const FETCH_BENEFITS_STUDENTS_FAILURE = TRAVEL_INSURANCE_FORM + 'fetchBenefitsStudents/failure';
export const FETCH_BENEFITS_STUDENTS_PENDING = TRAVEL_INSURANCE_FORM + 'fetchBenefitsStudents/pending';

export const FETCH_BENEFITS_PILGRIMAGE_SUCCESS = TRAVEL_INSURANCE_FORM + 'fetchBenefitsPilgrimage/success';
export const FETCH_BENEFITS_PILGRIMAGE_FAILURE = TRAVEL_INSURANCE_FORM + 'fetchBenefitsPilgrimage/failure';
export const FETCH_BENEFITS_PILGRIMAGE_PENDING = TRAVEL_INSURANCE_FORM + 'fetchBenefitsPilgrimage/pending';

export const collectTravelInsuranceQuoteData = () => {
    return {
        type: COLLECT_TRAVEL_INSURANCE_QUOTE_FORM_DATA,
    };
};

export const updateTravelInsuranceQuoteData = () => ({
    type: UPDATE_TRAVEL_INSURANCE_QUOTE_FORM_DATA,
});

// export const collectMotorInsuranceKeQuoteData = () => ({ type: COLLECT_KE_MOTOR_INSURANCE_QUOTE_FORM_DATA });
// export const collectThirdPartyQuoteData = () => ({ type: COLLECT_KE_THIRD_PARTY_DATA});
export const collectShareQuoteFormData = () => ({
    type: COLLECT_SHARE_QUOTE_FORM_DATA,
});

// export const submitMotorInsuranceQuoteSuccess = () => ({
// 	type: SUBMIT_MOTOR_INSURANCE_QUOTE_SUCCESS,
// 	value,
// });

export const shareQuoteSuccess = (value) => ({
    type: SHARE_MOTOR_INSURANCE_QUOTE_SUCCESS,
    value,
});

export const shareQuoteFailure = (error) => ({
    type: SHARE_MOTOR_INSURANCE_QUOTE_FAILURE,
    error,
});

export const calculateTravelInsurancePremiumSuccess = (value) => ({
    type: CALCULATE_TRAVEL_INSURANCE_PREMIUM_SUCCESS,
    value,
});

export const triggerFetchAllCountries = () => ({
    type: TRIGGER_FETCH_ALL_COUNTRIES,
});

export const fetchAllCountriesSuccess = (value) => ({
    type: FETCH_ALL_COUNTRIES_SUCCESS,
    value,
});

export const fetchAllCountriesFailure = (error) => ({
    type: FETCH_ALL_COUNTRIES_FAILURE,
    error,
});

export const fetchAllCountriesPending = () => ({
    type: FETCH_ALL_COUNTRIES_PENDING,
});

export const triggerFetchBenefitsEurope = () => ({
    type: TRIGGER_FETCH_BENEFITS_EUROPE,
});

export const triggerFetchBenefitsWorldWide = () => ({
    type: TRIGGER_FETCH_BENEFITS_WORLDWIDE,
});

export const triggerFetchBenefitsAfrica = () => ({
    type: TRIGGER_FETCH_BENEFITS_AFRICA,
});

export const triggerFetchBenefitsAsia = () => ({
    type: TRIGGER_FETCH_BENEFITS_ASIA,
});

export const triggerFetchBenefitsStudents = () => ({
    type: TRIGGER_FETCH_BENEFITS_STUDENTS,
});
export const triggerFetchBenefitsPilrimage = () => ({
    type: TRIGGER_FETCH_BENEFITS_PILGRIMAGE,
});

export const fetchBenefitsEuropeSuccess = (value) => ({
    type: FETCH_BENEFITS_EUROPE_SUCCESS,
    value,
});

export const fetchBenefitsEuropeFailure = (error) => ({
    type: FETCH_BENEFITS_EUROPE_FAILURE,
    error,
});

export const fetchBenefitsEuropePending = () => ({
    type: FETCH_BENEFITS_EUROPE_PENDING,
});

export const fetchBenefitsWorldWideSuccess = (value) => ({
    type: FETCH_BENEFITS_WORLD_WIDE_SUCCESS,
    value,
});

export const fetchBenefitsWorldWideFailure = (error) => ({
    type: FETCH_BENEFITS_WORLD_WIDE_FAILURE,
    error,
});

export const fetchBenefitsWorldWidePending = () => ({
    type: FETCH_BENEFITS_WORLD_WIDE_PENDING,
});

export const fetchBenefitsAfricaSuccess = (value) => ({
    type: FETCH_BENEFITS_AFRICA_SUCCESS,
    value,
});

export const fetchBenefitsAfricaFailure = (error) => ({
    type: FETCH_BENEFITS_AFRICA_FAILURE,
    error,
});

export const fetchBenefitsAfricaPending = () => ({
    type: FETCH_BENEFITS_AFRICA_PENDING,
});

export const fetchBenefitsAsiaSuccess = (value) => ({
    type: FETCH_BENEFITS_ASIA_SUCCESS,
    value,
});

export const fetchBenefitsAsiaFailure = (error) => ({
    type: FETCH_BENEFITS_ASIA_FAILURE,
    error,
});

export const fetchBenefitsAsiaPending = () => ({
    type: FETCH_BENEFITS_ASIA_PENDING,
});

export const fetchBenefitsStudentSuccess = (value) => ({
    type: FETCH_BENEFITS_STUDENTS_SUCCESS,
    value,
});

export const fetchBenefitsStudentFailure = (error) => ({
    type: FETCH_BENEFITS_STUDENTS_FAILURE,
    error,
});

export const fetchBenefitsStudentPending = () => ({
    type: FETCH_BENEFITS_STUDENTS_PENDING,
});

export const fetchBenefitsPilgrimageSuccess = (value) => ({
    type: FETCH_BENEFITS_PILGRIMAGE_SUCCESS,
    value,
});

export const fetchBenefitsPilgrimageFailure = (error) => ({
    type: FETCH_BENEFITS_PILGRIMAGE_FAILURE,
    error,
});

export const fetchBenefitsPilgrimagePending = () => ({
    type: FETCH_BENEFITS_PILGRIMAGE_PENDING,
});

export const setPlans = (value) => ({
    type: PLAN,
    value,
});

export const setSegment = (value) => ({
    type: SEGMENT,
    value,
});

export const setSection = (value) => ({
    type: SECTION,
});
// export const submitMotorInsuranceQuoteFailure = () => ({
// });

export const setExpiredAuth = (value) => ({
    type: TOKEN_IS_EXPIRED,
    value,
});

export const addCover = (value) => ({
    type: TRAVEL_INSURANCE_ADD_COVER,
    value,
});

// Form values
export const SET_CURRENTLY_IN_KENYA_VALUE = TRAVEL_INSURANCE_FORM_SET_VALUE + 'currentlyInKenyaValue';
export const SET_CURRENTLY_IN_KENYA_VALID = TRAVEL_INSURANCE_FORM_SET_VALID + 'currentlyInKenyaValid';

export const SET_TRIP_TYPE_VALUE = TRAVEL_INSURANCE_FORM_SET_VALUE + 'tripTypeValue';
export const SET_TRIP_TYPE_VALID = TRAVEL_INSURANCE_FORM_SET_VALID + 'tripTypeValid';
export const SET_COVER_FOR_VALUE = TRAVEL_INSURANCE_FORM_SET_VALUE + 'coverForValue';
export const SET_COVER_FOR_VALID = TRAVEL_INSURANCE_FORM_SET_VALID + 'coverForValid';

export const SET_NAME_VALUE = TRAVEL_INSURANCE_FORM_SET_VALUE + 'nameValue';
export const SET_NAME_VALID = TRAVEL_INSURANCE_FORM_SET_VALID + 'nameValid';
export const SET_EMAIL_VALUE = TRAVEL_INSURANCE_FORM_SET_VALUE + 'emailValue';
export const SET_EMAIL_VALID = TRAVEL_INSURANCE_FORM_SET_VALID + 'emailValid';
export const SET_PHONE_NO_VALUE = TRAVEL_INSURANCE_FORM_SET_VALUE + 'phoneNoValue';
export const SET_PHONE_NO_VALID = TRAVEL_INSURANCE_FORM_SET_VALID + 'phoneNoValid';

export const SET_DEPARTURE_COUNRTY_VALUE = TRAVEL_INSURANCE_FORM_SET_VALUE + 'depatureCountryValue';
export const SET_DEPARTURE_COUNRTY_VALID = TRAVEL_INSURANCE_FORM_SET_VALID + 'depatureCountryValid';
export const SET_DESTINATION_COUNRTY_VALUE = TRAVEL_INSURANCE_FORM_SET_VALUE + 'destinationCountryValue';
export const SET_DESTINATION_COUNRTY_VALID = TRAVEL_INSURANCE_FORM_SET_VALID + 'destinationCountryValid';
export const SET_DEPARTURE_DATE_VALUE = TRAVEL_INSURANCE_FORM_SET_VALUE + 'depatureDateValue';
export const SET_DEPARTURE_DATE_VALID = TRAVEL_INSURANCE_FORM_SET_VALID + 'depatureDateValid';

export const SET_RETURN_DATE_VALUE = TRAVEL_INSURANCE_FORM_SET_VALUE + 'returnDateValue';
export const SET_RETURN_DATE_VALID = TRAVEL_INSURANCE_FORM_SET_VALID + 'returnDateValid';

export const SET_DOB_VALUE = TRAVEL_INSURANCE_FORM_SET_VALUE + 'DOBValue';
export const SET_DOB_VALID = TRAVEL_INSURANCE_FORM_SET_VALID + 'DOBValid';

export const SET_NO_OF_TRAVELLERS_VALUE = TRAVEL_INSURANCE_FORM_SET_VALUE + 'noOfTravellersValue';
export const SET_NO_OF_TRAVELLERS_VALID = TRAVEL_INSURANCE_FORM_SET_VALID + 'noOfTravellersValid';

export const SET_NO_OF_MINORS_VALUE = TRAVEL_INSURANCE_FORM_SET_VALUE + 'noOfMinorsValue';
export const SET_NO_OF_MINORS_VALID = TRAVEL_INSURANCE_FORM_SET_VALID + 'noOfMinorsValid';

export const SET_NO_OF_ADULTS_VALUE = TRAVEL_INSURANCE_FORM_SET_VALUE + 'noOfAdultsValue';
export const SET_NO_OF_ADULTS_VALID = TRAVEL_INSURANCE_FORM_SET_VALID + 'noOfAdultsValid';

export const SET_NO_OF_SENIORS_VALUE = TRAVEL_INSURANCE_FORM_SET_VALUE + 'noOfSeniorsValue';
export const SET_NO_OF_SENIORS_VALID = TRAVEL_INSURANCE_FORM_SET_VALUE + 'noOfSeniorsValid';

export const SET_NO_OF_SENIORS_76_VALUE = TRAVEL_INSURANCE_FORM_SET_VALUE + 'noOfSeniors76Value';
export const SET_NO_OF_SENIORS_76_VALID = TRAVEL_INSURANCE_FORM_SET_VALID + 'noOfSeniors76Valid';

export const SET_NO_OF_SENIORS_81_VALUE = TRAVEL_INSURANCE_FORM_SET_VALUE + 'noOfSeniors81Value';
export const SET_NO_OF_SENIORS_81_VALID = TRAVEL_INSURANCE_FORM_SET_VALID + 'noOfSeniors81Valid';

export const SET_SELECTED_COVER_VALUE = TRAVEL_INSURANCE_FORM_SET_VALUE + 'selectTravelCover';
export const SET_SELECTED_COVER_VALID = TRAVEL_INSURANCE_FORM_SET_VALID + 'selectTravelCover';

export const UG_MOTOR_INSURANCE_SIDEBAR_OPEN_VALUE = TRAVEL_INSURANCE_FORM_SET_VALUE + 'sidebarOpen';
export const UG_MOTOR_INSURANCE_SHARE_QUOTE_VALUE = UG_MOTOR_QOUTE_FORM + 'shareQuote';

// action creators
export const setCurrentlyInKenyaValue = (value) => ({
    type: SET_CURRENTLY_IN_KENYA_VALUE,
    value,
});

export const setCurrentlyInKenyaValid = (error) => ({
    type: SET_TRIP_TYPE_VALID,
    error,
});

export const setNameValue = (value) => ({
    type: SET_NAME_VALUE,
    value,
});

export const setNameValid = (error) => ({
    type: SET_NAME_VALID,
    error,
});

export const setEmailValue = (value) => ({
    type: SET_EMAIL_VALUE,
    value,
});

export const setEmailValid = (error) => ({
    type: SET_EMAIL_VALID,
    error,
});

export const setPhoneNoValue = (value) => ({
    type: SET_PHONE_NO_VALUE,
    value,
});

export const setPhoneNoValid = (error) => ({
    type: SET_PHONE_NO_VALID,
    error,
});

export const setTripTypeValue = (value) => ({
    type: SET_TRIP_TYPE_VALUE,
    value,
});

export const setTripTypeValid = (error) => ({
    type: SET_TRIP_TYPE_VALID,
    error,
});

export const setCoverForValue = (value) => ({
    type: SET_COVER_FOR_VALUE,
    value,
});

export const setCoverForValid = (error) => ({
    type: SET_COVER_FOR_VALID,
    error,
});

export const setDepartureCountryValue = (value) => ({
    type: SET_DEPARTURE_COUNRTY_VALUE,
    value,
});

export const setDepartureCountryValid = (error) => ({
    type: SET_DEPARTURE_COUNRTY_VALID,
    error,
});

export const setDestinationCountryValue = (value) => ({
    type: SET_DESTINATION_COUNRTY_VALUE,
    value,
});

export const setDestinationCountryValid = (error) => ({
    type: SET_DESTINATION_COUNRTY_VALID,
    error,
});

export const setDepatureDateValue = (value) => ({
    type: SET_DEPARTURE_DATE_VALUE,
    value,
});

export const setDepatureDateValid = (error) => ({
    type: SET_DEPARTURE_DATE_VALID,
    error,
});

export const setDobDateValue = (value) => ({
    type: SET_DOB_VALUE,
    value,
});

export const setDobDateValid = (error) => ({
    type: SET_DOB_VALID,
    error,
});

export const setReturnDateValue = (value) => ({
    type: SET_RETURN_DATE_VALUE,
    value,
});

export const setReturnDateValid = (error) => ({
    type: SET_RETURN_DATE_VALID,
    error,
});

export const setNoOfTravellersValue = (value) => ({
    type: SET_NO_OF_TRAVELLERS_VALUE,
    value,
});

export const setNoOfTravellersValid = (error) => ({
    type: SET_NO_OF_TRAVELLERS_VALID,
    error,
});

export const setNoOfMinorsValue = (value) => ({
    type: SET_NO_OF_MINORS_VALUE,
    value,
});

export const setNoOfMinorsValid = (error) => ({
    type: SET_NO_OF_MINORS_VALID,
    error,
});

export const setNoOfAdultsValue = (value) => ({
    type: SET_NO_OF_ADULTS_VALUE,
    value,
});

export const setNoOfAdultsValid = (error) => ({
    type: SET_NO_OF_ADULTS_VALID,
    error,
});

export const setNoOfSeniorsValue = (value) => ({
    type: SET_NO_OF_SENIORS_VALUE,
    value,
});

export const setNoOfSeniorsValid = (error) => ({
    type: SET_NO_OF_SENIORS_VALID,
    error,
});

export const setNoOfSeniors76Value = (value) => ({
    type: SET_NO_OF_SENIORS_76_VALUE,
    value,
});

export const setNoOfSeniors76Valid = (error) => ({
    type: SET_NO_OF_SENIORS_76_VALID,
    error,
});

export const setNoOfSeniors81Value = (value) => ({
    type: SET_NO_OF_SENIORS_81_VALUE,
    value,
});

export const setNoOfSeniors81Valid = (error) => ({
    type: SET_NO_OF_SENIORS_81_VALID,
    error,
});

export const initializeQuoteForm = () => ({
    type: REINITIALIZE,
});

export const setShareEmailValue = (value) => ({
    type: SET_SHARE_EMAIL_VALUE,
    value,
});

export const setShareEmailValid = (error) => ({
    type: SET_SHARE_EMAIL_VALID,
    error,
});

export const setSideBarOpen = (value) => ({
    type: UG_MOTOR_INSURANCE_SIDEBAR_OPEN_VALUE,
    value,
});
export const setShowShareModal = (value) => ({
    type: UG_MOTOR_INSURANCE_SHARE_QUOTE_VALUE,
    value,
});

export const setSelectedCoverValue = (value) => ({
    type: SET_SELECTED_COVER_VALUE,
    value,
});
export const setSelectedCoverValid = (error) => ({
    type: SET_SELECTED_COVER_VALID,
    error,
});
